
<mat-form-field formGroupName="firstChildGroup" appearance="outline">
  <mat-label>{{labelField}}</mat-label>
  <mat-select (selectionChange)="onChangeSelect($event)" [multiple]="multiple" [formControlName]="formControlField" >
    <input class="inputSearchSelect" type="text"
      (keyup)="onKey($event.target.value)" placeholder="Pesquisar" autocomplete="off" (keydown)="$event.stopPropagation()">
      @if (hasNullSelectField) {
        <mat-option ngValue="null">
          Selecione
        </mat-option>
      }
      @for (item of selectedList; track item; let i = $index) {
        <mat-option [disabled]="preSelectedBlock && preSelectedlist[i] && item[idField] == preSelectedlist[i][idField]" [value]="item[idField]">
          {{item[nameField]}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>